import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useEffect, useState } from "react";
import Home from "../Home";
import SignIn from "../Auth/Signin";
import Register from "../Auth/Register";
import ProtectedRoute from "../Shared/ProtectedRoutes";
import MyExam from "../Home/MyExam";
import Dashboard from "../Teacher/Dashboard";
import ExamManager from "../Teacher/ExamManagement/ExamManager";
import ApiServices from "../Services/ApiServices";
import Loader from "./Loader";
import NotFound from "./NotFound";
import BlogAsPosts from "../Home/BlogAsPosts";
import BlogViewer from "../Home/BlogViewer";
import HonorBoardExams from "../Home/HonorBoardExams";
import TeacherProfile from "../Home/TeacherProfile"; // Import the TeacherProfile component
import PlatformTeachers from "../Home/PlatformTeachers";
import WebsiteCourses from "../Home/WebsiteCourses";
import Pricing from "../Home/Pricing";
import Forbidden from "./Forbidden";
import ExamResult from "../Home/ExamResult";
import AboutUs from "../Home/AboutUs"; // Add this import
import TeacherDocumentation from "../Home/TeacherDocumentation";
import WebsiteCourseContent from "../Home/WebsiteCourseContent";
import MyCourses from "../Home/MyCourses";
import CourseContent from "../Home/CourseContent";
import ReadMore from "../Home/ReadMore";
import MozakaraStudent from "../Home/MozakaraStudent";
import ChangeUserPassword from "../Auth/ChangeUserPassword";
import AdminDashboard from "../Admin/AdminDashboard";
import AddTeacher from "../Admin/AddTeacher";
import EditTeacher from "../Admin/EditTeacher";
import QueryExecutor from "../Admin/QueryExecutor";
import AddSubscription from "../Admin/AddSubscription";
import EditSubscription from "../Admin/EditSubscription";
import UserSubscriptionTransaction from "../Admin/UserSubscriptionTransaction";
import AddSubscriptionAddon from "../Admin/AddSubscriptionAddon";
import EditSubscriptionAddon from "../Admin/EditSubscriptionAddon";
import AddPlan from "../Admin/AddPlan";
import AdminPlanFeature from "../Admin/AdminPlanFeature";
import AddPlanFeature from "../Admin/AddPlanFeature";
import AddAppView from "../Admin/AddAppView";
import EditAppView from "../Admin/EditAppView";
import AddAdsViewer from "../Admin/AddAdsViewer";
import EditAdsViewer from "../Admin/EditAdsViewer";
import SeedData from "../Admin/SeedData";
import CouponManager from "../Admin/CouponManager";
import TeacherExamResult from "../Teacher/TeacherExamResult";
import AddEditExamDetails from "../Teacher/ExamManagement/AddEditExamDetails";
import StudentManager from "../Teacher/StudentManagement/StudentManager";
import StudentDetails from "../Teacher/StudentManagement/StudentDetails";
import BlogManager from "../Teacher/BlogManagement/BlogManager";
import MozakaraManager from "../Teacher/MozakaraManagement/MozakaraManager";
import CourseVideoManager from "../Teacher/CourseManager/CourseVideoManager";
import CourseVideoQuizes from "../Teacher/CourseManager/CourseVideoQuizes";
import { storageHelper } from "../../Helpers/storageHelper";
import ApkViewer from "../Home/ApkViewer";
import ExamProtectionV1 from "../Home/ExamProtectionV1";
import RegisterAsTeacher from '../Teacher/RegisterAsTeacher';
import OTPSender from '../Teacher/OTPSender';
import SuperAdminnOTP from '../Auth/SuperAdminnOTP';
import ForgotPassword from '../Auth/ForgotPassword';
import ResetPassword from '../Auth/ResetPassword';
import MaintenanceMode from './MaintenanceMode';
import OurServices from '../Home/OurServices';
import CertificateViewer from "./CertificateViewer";
import StudentInfo from "../Home/StudentInfo";
import StudentSelfExam from "../Home/rafiqtool/StudentSelfExam";
import PaymentResult from "../Payment/PaymentResult";
import PaymentCallback from "../Payment/PaymentCallback";
import FawaterakPaymentPage from "../Payment/FawaterakPaymentPage";
import ZatounaDashboard from "../Home/rafiqtool/ZatounaDashboard";
import Zakerly from "../Home/rafiqtool/Zakerly";
import StoryLearnComponent from "../Home/rafiqtool/StoryLearnComponent";
import StepperDemo from "../Teacher/StepperDemo/StepperDemo";
import ShareQrData from "./ShareQrData";

const TeacherRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isTeacher, setIsTeacher] = useState(false);
  const token = storageHelper.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    const verifyTeacherRole = async () => {
      try {
        if (!token) {
          setIsLoading(false);
          navigate("/signin", { replace: true });
          return;
        }

        const response = await ApiServices.get("verifyRole");
        const role = typeof response === "string" ? response : response.role;

        if (role === "Teacher" || role === "SuperAdmin" || role === "superadmin") {
          setIsTeacher(true);
        } else {
          setIsTeacher(false);
          // Force a page reload when redirecting to home
          window.location.href = "/";
        }
      } catch (error) {
        setIsTeacher(false);
        // Force a page reload when redirecting to home
        window.location.href = "/";
      } finally {
        setIsLoading(false);
      }
    };

    verifyTeacherRole();
  }, [token, navigate]);

  if (isLoading) {
    return <Loader text="جاري التحقق من الصلاحيات..." />;
  }

  if (!isTeacher) {
    return null; // Return null since we're handling redirect in useEffect
  }

  return children;
};

const ProtectedAdminRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const token = storageHelper.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    const verifyAdminRole = async () => {
      try {
        if (!token) {
          setIsLoading(false);
          navigate("/signin", { replace: true });
          return;
        }
        const response = await ApiServices.get("verifyRole");
        // Support both { role: 'SuperAdmin' } and 'SuperAdmin' response
        const role = typeof response === "string" ? response : response.role;
        if (role === "superadmin" || role === "SuperAdmin") {
          const otpVerified = storageHelper.getItem("super_admin_otp_verified");
          if (otpVerified === "true") {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
            navigate("/superadmin-otp", { replace: true });
          }
        } else {
          setIsAdmin(false);
          window.location.href = "/";
        }
      } catch (error) {
        setIsAdmin(false);
        window.location.href = "/";
      } finally {
        setIsLoading(false);
      }
    };
    verifyAdminRole();
  }, [token, navigate]);

  if (isLoading) {
    return <Loader text="جاري التحقق من صلاحيات الأدمن..." />;
  }
  if (!isAdmin) {
    return null;
  }
  return children;
};

const TeacherResponsiveScope = () => {
  const location = useLocation();

  useEffect(() => {
    const teacherOnlyPaths = ["/register-teacher", "/otp"];
    const isTeacherPage =
      (location.pathname.startsWith("/teacher/") || location.pathname === "/teacher") ||
      teacherOnlyPaths.includes(location.pathname);

    document.body.classList.toggle("teacher-route", isTeacherPage);

    return () => {
      document.body.classList.remove("teacher-route");
    };
  }, [location.pathname]);

  return (
    <>
    <Toaster position="top-center" reverseOrder={false} />
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register-teacher" element={<RegisterAsTeacher />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/superadmin-otp" element={<SuperAdminnOTP />} />
      <Route path="/maintenance" element={<MaintenanceMode />} />
      <Route path="/" element={<Home />} />
      <Route path="/honor-board" element={<HonorBoardExams />} />
      <Route path="/blogs" element={<BlogAsPosts />} />
      <Route path="/blog-viewer/:postId" element={<BlogViewer />} />
      <Route path="/course/:id" element={<WebsiteCourseContent />} />
      <Route path="/certificate/:id" element={<CertificateViewer />} />
      <Route path="/share-qr" element={<ShareQrData fullPage={true} />} />
      <Route path="/share-qr-data" element={<ShareQrData fullPage={true} />} />
      <Route
        path="/exam/v1/:id"
        element={
          <ProtectedRoute>
            <ExamProtectionV1></ExamProtectionV1>
          </ProtectedRoute>
        }
      ></Route>
      <Route
        path="/exam-result/:id"
        element={
          <ProtectedRoute>
            <ExamResult />
          </ProtectedRoute>
        }
      />
      <Route
        path="/myexam"
        element={
          <ProtectedRoute>
            <MyExam />
          </ProtectedRoute>
        }
      />
      <Route path="/payment-callback" element={<PaymentCallback />} />
      <Route path="/fawaterak-payment" element={
        <ProtectedRoute>
          <FawaterakPaymentPage />
        </ProtectedRoute>
      } />
      <Route
        path="/mycourses"
        element={
          <ProtectedRoute>
            <MyCourses />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mycourses/:id"
        element={
          <ProtectedRoute>
            <CourseContent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/student-info"
        element={
          <ProtectedRoute>
            <StudentInfo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/student/self-exam"
        element={
          <ProtectedRoute>
            <StudentSelfExam />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mozakara"
        element={
          <ProtectedRoute>
            <MozakaraStudent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/zatouna"
        element={
          <ProtectedRoute>
            <ZatounaDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/zakerly"
        element={
          <ProtectedRoute>
            <Zakerly />
          </ProtectedRoute>
        }
      />
      <Route
        path="/story-learn"
        element={
          <ProtectedRoute>
            <StoryLearnComponent />
          </ProtectedRoute>
        }
      />
      {/* Teacher Routes */}
      <Route
        path="/teacher/dashboard"
        element={
          <TeacherRoute>
            <Dashboard />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/exams"
        element={
          <TeacherRoute>
            <ExamManager />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/exam-result/:examId"
        element={
          <TeacherRoute>
            <TeacherExamResult />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/exams/add"
        element={
          <TeacherRoute>
            <Navigate to="/teacher/dashboard?tab=ExamManager" replace />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/exams/edit/:examId"
        element={
          <TeacherRoute>
            <Navigate to="/teacher/dashboard?tab=ExamManager" replace />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/exams/details/:examId"
        element={
          <TeacherRoute>
            <AddEditExamDetails />
          </TeacherRoute>
        }
      />
      {/* Student Management Routes */}
      <Route
        path="/teacher/students"
        element={
          <TeacherRoute>
            <StudentManager />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/students/add"
        element={
          <TeacherRoute>
            <Navigate to="/teacher/dashboard?tab=StudentManager" replace />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/students/edit/:studentId"
        element={
          <TeacherRoute>
            <Navigate to="/teacher/dashboard?tab=StudentManager" replace />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/students/view/:studentId"
        element={
          <TeacherRoute>
            <StudentDetails />
          </TeacherRoute>
        }
      />
      {/* New Route for Stepper Demo */}
      <Route
        path="/teacher/stepper-demo"
        element={
          <TeacherRoute>
            <StepperDemo />
          </TeacherRoute>
        }
      />
      {/* New Route for Platform Teachers */}
      <Route path="/teachers" element={<PlatformTeachers />} />

      {/* New Route for Website Courses */}
      <Route path="/courses" element={<WebsiteCourses />} />

      {/* New Route for Teacher Profile */}
      <Route path="/teacher-profile/:teacherId" element={<TeacherProfile />} />

      {/* New Route for Pricing */}
      <Route path="/pricing" element={<Pricing />} />

      {/* New Route for Payment Result - Handles Paymob Callback */}
      <Route path="/payment-result" element={<PaymentResult />} />

      {/* New Route for Teacher Documentation */}
      <Route path="/teacher-documentation" element={<TeacherDocumentation />} />

      {/* New Route for About Us */}
      <Route path="/about" element={<AboutUs />} />

      {/* New Route for Our Services */}
      <Route path="/services" element={<OurServices />} />
      <Route path="/services/:serviceId" element={<OurServices />} />

      {/* New Route for ApkViewer */}
      <Route path="/apk-viewer" element={<ApkViewer />} />

      {/* Public Route for ShareQrData */}
      <Route path="/share-qr" element={<ShareQrData />} />
      <Route path="/share-qr-data" element={<ShareQrData />} />

      <Route path="/service-details/:serviceId" element={<ReadMore />} />

      {/* New Route for Change Password */}
      <Route
        path="/change-password"
        element={
          <ProtectedRoute>
            <ChangeUserPassword />
          </ProtectedRoute>
        }
      />

      {/* New Route for Admin Dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedAdminRoute>
            <AdminDashboard />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/teachers/add"
        element={
          <ProtectedAdminRoute>
            <AddTeacher />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/teachers/edit/:id"
        element={
          <ProtectedAdminRoute>
            <EditTeacher />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/subscriptions/add"
        element={
          <ProtectedAdminRoute>
            <AddSubscription />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/subscriptions/edit/:id"
        element={
          <ProtectedAdminRoute>
            <EditSubscription />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/subscriptions/history/:id"
        element={
          <ProtectedAdminRoute>
            <UserSubscriptionTransaction />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/subscription-addons/add"
        element={
          <ProtectedAdminRoute>
            <AddSubscriptionAddon />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/subscription-addons/edit"
        element={
          <ProtectedAdminRoute>
            <EditSubscriptionAddon />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/plans/add"
        element={
          <ProtectedAdminRoute>
            <AddPlan />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/plans/edit"
        element={
          <ProtectedAdminRoute>
            <AddPlan />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/plans/features"
        element={
          <ProtectedAdminRoute>
            <AdminPlanFeature />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/plans/features/add"
        element={
          <ProtectedAdminRoute>
            <AddPlanFeature />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/seed-data"
        element={
          <ProtectedAdminRoute>
            <SeedData />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/app-viewer/add"
        element={
          <ProtectedAdminRoute>
            <AddAppView />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/app-viewer/edit"
        element={
          <ProtectedAdminRoute>
            <EditAppView />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/ads-viewer/add"
        element={
          <ProtectedAdminRoute>
            <AddAdsViewer />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/ads-viewer/edit"
        element={
          <ProtectedAdminRoute>
            <EditAdsViewer />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/query-executor"
        element={
          <ProtectedAdminRoute>
            <QueryExecutor />
          </ProtectedAdminRoute>
        }
      />
      <Route
        path="/admin/coupons"
        element={
          <ProtectedAdminRoute>
            <CouponManager />
          </ProtectedAdminRoute>
        }
      />

      {/* New Route for Blog Manager */}
      <Route
        path="/teacher/blogs"
        element={
          <TeacherRoute>
            <BlogManager />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/blogs/add"
        element={
          <TeacherRoute>
            <Navigate to="/teacher/dashboard?tab=Blog" replace />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/blogs/edit/:blogId"
        element={
          <TeacherRoute>
            <Navigate to="/teacher/dashboard?tab=Blog" replace />
          </TeacherRoute>
        }
      />

      {/* Course Management Routes */}
      <Route
        path="/teacher/courses/videos/:courseId"
        element={
          <TeacherRoute>
            <CourseVideoManager />
          </TeacherRoute>
        }
      />
      <Route
        path="/teacher/course-video-quizzes/:courseVideoId"
        element={
          <TeacherRoute>
            <CourseVideoQuizes />
          </TeacherRoute>
        }
      />

      {/* Mozakara Management Routes */}
      <Route
        path="/teacher/mozakara"
        element={
          <TeacherRoute>
            <MozakaraManager />
          </TeacherRoute>
        }
      />

      {/* New Route for OTPSender */}
      <Route path="/otp" element={<OTPSender />} />

      {/* Catch all route for 404 */}
      <Route path="*" element={<NotFound />} />
      <Route
        path="/forbidden"
        element={
          <Forbidden
            message={storageHelper.getItem("forbiddenMessage") || undefined}
          />
        }
      />
    </Routes>
    </>
  );
};

const AppRoutes = () => (
  <BrowserRouter>
    <TeacherResponsiveScope />
  </BrowserRouter>
);

export default AppRoutes;
